/**
 * product-grid-gallery.js
 * ------------------------------------------------------------
 * Powers the 2x2 image grid in snippets/product-grid-gallery.liquid.
 * When a color swatch is clicked (or Broadcast's variant object
 * changes), the 4 grid images swap to the images tagged with
 * that color in Shopify admin (via each image's ALT TEXT).
 *
 * Listens for THREE signals, in order of preference:
 *   1. document event "variant:change"          (common in many themes)
 *   2. document event "product:variant-change"  (alt naming some themes use)
 *   3. a plain click on any swatch/radio input near the product form
 *
 * If your theme's real event name differs, open the browser
 * console on a product page, click a swatch, and check
 * `window.dispatchEvent` calls — or just rely on the click
 * fallback, which works regardless of event naming.
 * ------------------------------------------------------------
 */
(function () {
  function initProductGridGallery(root) {
    var dataScript = root.querySelector('script[id^="PggData-"]');
    if (!dataScript) return;

    var data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (err) {
      console.error('[ProductGridGallery] could not parse image data', err);
      return;
    }

    var grid = root.querySelector('.pgg__grid');
    if (!grid) return;

    var cells = Array.prototype.slice.call(grid.querySelectorAll('.pgg__cell'));
    var allImages = data.images || [];
    var colorOptionName = (data.colorOptionName || 'Color').toLowerCase();

    function imagesForColor(colorValue) {
      if (!colorValue) return [];
      var needle = colorValue.toLowerCase().trim();
      return allImages.filter(function (img) {
        return (img.alt || '').toLowerCase().indexOf(needle) !== -1;
      });
    }

    function untaggedImages() {
      return allImages.filter(function (img) {
        return !img.alt;
      });
    }

    function renderImages(images) {
      var list = images.slice(0, 4);

      if (list.length < 4) {
        var pool = untaggedImages();
        for (var i = 0; i < pool.length && list.length < 4; i++) {
          if (list.indexOf(pool[i]) === -1) list.push(pool[i]);
        }
      }
      // last-resort: repeat existing matches so the grid isn't left empty
      var originalLength = images.length || 1;
      var guard = 0;
      while (list.length < 4 && images.length > 0 && guard < 4) {
        list.push(images[list.length % originalLength]);
        guard++;
      }
      if (!list.length) return;

      cells.forEach(function (cell, i) {
        var img = cell.querySelector('img');
        var source = list[i];
        if (!img || !source) return;

        cell.classList.add('pgg__cell--loading');
        var preload = new Image();
        preload.onload = function () {
          img.src = source.src;
          img.srcset = '';
          img.alt = source.alt || img.alt;
          cell.classList.remove('pgg__cell--loading');
        };
        preload.onerror = function () {
          cell.classList.remove('pgg__cell--loading');
        };
        preload.src = source.src;
      });
    }

    function bestColorMatchFromValues(values) {
      var best = { value: null, matches: [] };
      (values || []).forEach(function (value) {
        var matches = imagesForColor(value);
        if (matches.length > best.matches.length) {
          best = { value: value, matches: matches };
        }
      });
      return best;
    }

    function handleVariantChange(variant) {
      if (!variant) return;
      var best = bestColorMatchFromValues(variant.options);
      if (best.matches.length) {
        renderImages(best.matches);
      } else if (variant.featured_image || variant.featuredImage) {
        // No alt-tagged matches found — fall back to the variant's
        // single featured image repeated across the grid.
        var src = variant.featured_image ? variant.featured_image.src : variant.featuredImage;
        if (src) renderImages([{ src: src, alt: '' }]);
      }
    }

    // 1) Preferred: listen for theme-dispatched variant change events
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) handleVariantChange(e.detail.variant);
    });
    document.addEventListener('product:variant-change', function (e) {
      if (e.detail && e.detail.variant) handleVariantChange(e.detail.variant);
    });

    // 2) Fallback: direct click on swatches/radios anywhere in the product form
    var productForm = document.querySelector('form[action*="/cart/add"]');
    var scope = productForm ? productForm.closest('.shopify-section') || document : document;

    scope.addEventListener('click', function (e) {
      var target = e.target.closest(
        '[data-value], .color-swatch, .swatch, .swatch input, input[type="radio"], label[for]'
      );
      if (!target) return;

      var value =
        target.getAttribute('data-value') ||
        target.value ||
        target.getAttribute('value') ||
        target.textContent.trim();

      if (!value) return;
      var matches = imagesForColor(value);
      if (matches.length) renderImages(matches);
    });

    // 3) Initial paint based on whatever swatch/radio is pre-selected on load
    var selected = scope.querySelector(
      'input[type="radio"]:checked[name*="' + colorOptionName + '" i], .swatch.is-selected, .swatch--selected'
    );
    if (selected) {
      var initialValue =
        selected.value || selected.getAttribute('value') || selected.getAttribute('data-value');
      if (initialValue) {
        var initialMatches = imagesForColor(initialValue);
        if (initialMatches.length) renderImages(initialMatches);
      }
    }
  }

  function boot() {
    document.querySelectorAll('.pgg').forEach(initProductGridGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when merchant edits the section in the theme editor
  document.addEventListener('shopify:section:load', boot);
})();
